import React from "react";
import styles from "./style.module.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../../state";
import { isEqual } from "lodash";
import { TimingSessionInfo } from "../../../types/timingFeed";

export default function SessionInfo() {
  const info = useSelector(
    (state: RootState) => state.aks.v2.timing?.session?.info,
    isEqual,
  ) as TimingSessionInfo | undefined;

  const { eventShortName = null, name = null } =
    typeof info === "object" ? info : {};

  return (
    <div className={styles.infoContainer}>
      {eventShortName && name ? (
        <>
          <div>{eventShortName}</div>
          <div>{name}</div>
        </>
      ) : (
        "No active session"
      )}
    </div>
  );
}
